import { type UseQueryResult, useQuery } from 'react-query';
import {
  VendorCompanyService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_CompanyListDto,
} from '@wealthlane/api-services/wealthlane-customer-service';
import { CustomTableInfoType } from '../../pages/vendor_customer';
import { TableParams } from '../../types/common';

const useGetCustomerListData = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParams,
  enabled?: boolean
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_CompanyListDto | undefined,
  unknown
> => {
  const {
    filter,
    sorting,
    skipCount,
    maxResultCount,
    fromOnboardedDate,
    toOnboardedDate,
    statusIds,
    _force,
    brokerCompanyId,
    transferAgentCompanyId,
    companyTypes,
    featureSetIds,
    commissionId,
  } = tableInfo;

  const customerListData = useQuery(
    [
      'getCustomerList',
      filter,
      sorting,
      skipCount,
      maxResultCount,
      fromOnboardedDate,
      toOnboardedDate,
      statusIds,
      brokerCompanyId,
      transferAgentCompanyId,
      companyTypes,
      featureSetIds,
      commissionId,
      _force,
    ],
    async () => {
      return await handleRequest(
        VendorCompanyService.getApiCustomerApiAppVendorCompany(
          fromOnboardedDate,
          toOnboardedDate,
          statusIds,
          brokerCompanyId,
          transferAgentCompanyId,
          companyTypes,
          featureSetIds,
          commissionId,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    },
    {
      enabled: enabled !== false,
    }
  );

  return customerListData;
};

export default useGetCustomerListData;
